import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const PartQuantityColumn = ({ data }: Props) => {
	const {
		state: { dataPartSelected },
	} = useAssetDetailsContext();
	if (data?.id === -1) {
		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{dataPartSelected?.Qty}
				</Grid2>
			</Grid2>
		);
	} else if (data?.id !== -1) {
		return <>{data?.Qty}</>;
	} else return <></>;
};
